export default {
  'AUTHORIZATION_DETAIL_FORM': 'AUTHORIZATION_DETAIL_FORM',
  'AUTHORIZATIONS_WITHOUT_CLAIMS_SUCCESS': 'AUTHORIZATIONS_WITHOUT_CLAIMS_SUCCESS',
  'SET_FILTERS_CONFIGURATION': 'SET_FILTERS_CONFIGURATION',
  'AUTHORIZATION_DETAIL': 'AUTHORIZATION_DETAIL',
  'RESET_AUTHORIZATION_STATE': 'RESET_AUTHORIZATION_STATE',
  'SET_CURRENT_FORM': 'SET_CURRENT_FORM',
  'AUTHORIZATION_FORM_LOAD_SUCCESS': 'AUTHORIZATION_FORM_LOAD_SUCCESS',
  'AUTHORIZATION_LOADING': 'AUTHORIZATION_LOADING',
  'AUTHORIZATION_LOAD_ERROR': 'AUTHORIZATION_LOAD_ERROR',
  'SET_CURRENT_STEP': 'SET_CURRENT_STEP',
  'SET_STEP_ERROR': 'SET_STEP_ERROR',
  'SET_INPUTS': 'SET_INPUTS',
  'SET_ERROR': 'SET_ERROR',
  'SET_CREATE_AUTHORIZATION_ACTION': 'SET_CREATE_AUTHORIZATION_ACTION',
  'SET_ACCOUNTS_SEARCH_VALUE': 'SET_ACCOUNTS_SEARCH_VALUE',
  'SET_AUTHORIZATION_SPONSOR_STATIC_DOCUMENTS': 'SET_AUTHORIZATION_SPONSOR_STATIC_DOCUMENTS',
  'SET_AUTHORIZATION_SPONSOR_STATIC_DOCUMENTS_ERROR': 'SET_AUTHORIZATION_SPONSOR_STATIC_DOCUMENTS_ERROR',
  'AUTHORIZATION_DETAIL_V2_FILE': 'AUTHORIZATION_DETAIL_V2_FILE',
  'AUTHORIZATION_DETAIL_V2_FILE_ERROR': 'AUTHORIZATION_DETAIL_V2_FILE_ERROR',
  'SET_AUTHORIZATION_PRE_INVOICE': 'SET_AUTHORIZATION_PRE_INVOICE',
  'SET_AUTHORIZATION_PRE_INVOICE_ERROR': 'SET_AUTHORIZATION_PRE_INVOICE_ERROR',
  'CLEAR_AUTHORIZATION_PRE_INVOICE': 'CLEAR_AUTHORIZATION_PRE_INVOICE',
  'SET_NEW_AUTHORIZATION_STATUS': 'SET_NEW_AUTHORIZATION_STATUS',
  'SET_AUTHORIZATION_INVOICE': 'SET_AUTHORIZATION_INVOICE',
  'CLEAR_AUTHORIZATION_INVOICE': 'CLEAR_AUTHORIZATION_INVOICE',
  'DELETE_AUTHORIZATION_INVOICE': 'DELETE_AUTHORIZATION_INVOICE'
}
